import { render, staticRenderFns } from "./CheckoutStep.vue?vue&type=template&id=4b64e6da&scoped=true&"
import script from "./CheckoutStep.vue?vue&type=script&lang=js&"
export * from "./CheckoutStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64e6da",
  null
  
)

export default component.exports